module.exports = "/_next/static/images/dda0b2b0c7ea1173e21b993717342041-nuapp@2x.png.webp";